"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/Sections/TrialOffer/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);

var _TrialOffer = require('web/screens/onboardingShared/TrialOffer'); var _TrialOffer2 = _interopRequireDefault(_TrialOffer);






















const TrialOfferSection = props => {
  const [prices, setPrices] = _react.useState([])
  const [isLoadingPricing, setIsLoadingPricing] = _react.useState.call(void 0, true)
  const [hasPricingError, setHasPricingError] = _react.useState.call(void 0, false)
  const [isStarting, setIsStarting] = _react.useState.call(void 0, false)
  // Ref guard, not state: React 17 doesn't batch the setIsStarting render
  // outside event handlers, so a rapid double-click re-enters before the
  // button disables — each entry would run the whole submit/login/checkout
  // chain (mirrors OnboardingPayment's onStart guard).
  const startingRef = _react.useRef.call(void 0, false)
  const [actionError, setActionError] = _react.useState()

  const loadPricing = _react.useCallback.call(void 0, () => {
    setHasPricingError(false)
    setIsLoadingPricing(true)
    _client2.default.getOnboardingPrices()
      .then(response => {
        setPrices(response.Items || [])
        setIsLoadingPricing(false)
      })
      .catch(err => {
        log.error(err instanceof Error ? err : String(err))
        props.onPricingError()
        setHasPricingError(true)
        setIsLoadingPricing(false)
      })
    // The setup hook owns a stable logical handler for this mounted step.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  _react.useEffect.call(void 0, loadPricing, [loadPricing])

  const run = _react.useCallback.call(void 0, (action, handler) => {
    if (startingRef.current) return
    startingRef.current = true
    setIsStarting(true)
    setActionError(undefined)
    handler(action)
      .catch(() => {
        setActionError("We couldn't finish setting up your account. Please try again.")
      })
      .finally(() => {
        startingRef.current = false
        setIsStarting(false)
      })
  }, [])

  return (
    _react2.default.createElement(_TrialOffer2.default, {
      prices: prices,
      hasSms: props.hasSms,
      hasTeamChat: props.hasTeamChat,
      hasExternalChat: props.hasExternalChat,
      selectedTier: props.selectedTier,
      onSelectedTierChange: props.onSelectedTierChange,
      isLoadingPricing: isLoadingPricing,
      hasPricingError: hasPricingError,
      onRetryPricing: loadPricing,
      isStarting: isStarting,
      actionError: props.error || actionError,
      onBack: props.onBack,
      onStart: action => run(action, props.onStart),
      onSkip: action => run(action, props.onSkip),
      onFreeContinue: action => run(action, props.onFreeContinue),
      onDemo: props.onDemo,
      onDemoViewed: props.onDemoViewed,
      onViewed: props.onViewed,
      onSkipDialogViewed: props.onSkipDialogViewed, __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}}
    )
  )
}

exports. default = TrialOfferSection
